import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { Skeleton, UiKit } from 'components';
import { useFeatureToggle } from '../context';
import { InfoLink } from 'components/Tables/CustomTable';

export default function FeatureToggleCard({ title = '', description = '' }) {
  const {
    id,
    docUrl,
    isEnabled,
    isLoading,
    isProcessing,
    onModalOpen
  } = useFeatureToggle();

  return (
    <div className={cn(styles.container, { [styles.active]: isEnabled })}>
      <div className={styles.row}>
        <div className={styles.cell}>
          <h5 className={styles.title}>{title}</h5>
          <InfoLink url={docUrl} className={styles.link} />
        </div>
        <If
          test={!isLoading}
          otherwise={
            <Skeleton rounded width={32} height={16} className="m-0" />
          }
        >
          <UiKit.Toggle
            isActive={isEnabled}
            disabled={isProcessing}
            onChange={() => onModalOpen(id)}
          />
        </If>
      </div>
      <p className={styles.description}>{description}</p>
    </div>
  );
}
